export const LOADING_PURCHASEINVOICES = "LOADING_PURCHASEINVOICES";
export const GET_PURCHASEINVOICES_LIST = "GET_PURCHASEINVOICES_LIST";
export const REMOVE_PURCHASEINVOICES = "REMOVE_PURCHASEINVOICES";
export const ADD_PURCHASEINVOICES = "ADD_PURCHASEINVOICES";
export const UPDATE_PURCHASEINVOICES = "UPDATE_PURCHASEINVOICES";
export const GET_PURCHASEINVOICESBYID = "GET_PURCHASEINVOICESBYID";
export const GET_PRODUCTORDER = "GET_PRODUCTORDER";
export const LOADING_PRODUCTORDER = "LOADING_PRODUCTORDER";

export const LOADING_PURCHASE_INVOICE_DOCUMENT = "LOADING_PURCHASE_INVOICE_DOCUMENT";
export const REMOVE_PURCHASE_INVOICE_DOCUMENT = "REMOVE_PURCHASE_INVOICE_DOCUMENT";
export const ADD_PURCHASE_INVOICE_DOCUMENT = "ADD_PURCHASE_INVOICE_DOCUMENT";
export const ADD_PURCHASE_INVOICE_MULTI_DOCUMENT = "ADD_PURCHASE_INVOICE_MULTI_DOCUMENT";
export const DOWNLOAD_PURCHASE_INVOICE_DOCUMENT = "DOWNLOAD_PURCHASE_INVOICE_DOCUMENT";
export const GET_PURCHASE_INVOICE_DOCUMENT_LIST = "GET_PURCHASE_INVOICE_DOCUMENT_LIST";